import React from 'react';
import AvProjIconTag from '@components/AvProjTag';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

export enum EntitiesLabels {
  IDENTITIES = 'Identities',
  TENANTS = 'Tenants',
  GROUPS = 'Groups',
  ASSETS = 'Assets',
}

const LabelToUber: { [key in EntitiesLabels]: string } = {
  [EntitiesLabels.TENANTS]: 'uber_tenants',
  [EntitiesLabels.IDENTITIES]: 'uber_users',
  [EntitiesLabels.GROUPS]: 'uber_security_groups',
  [EntitiesLabels.ASSETS]: 'uber_assets',
};

interface CountByEntitiesProps {
  data: any;
}

export const CountByEntities: React.FC<CountByEntitiesProps> = ({ data }) => (
  <Box sx={{ ...flex.itemsCenter, gap: 2 }}>
    {Object.keys(LabelToUber).map(entity => (
      <AvProjIconTag projName={LabelToUber[entity]} total={data?.[entity]} tooltipText />
    ))}
  </Box>
);
